import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center pa-4" }

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorEmail',
  props: {
  isVisible: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:isVisible"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;
const internalVisible = ref(props.isVisible);

watch(
  () => props.isVisible,
  (newVal) => {
    internalVisible.value = newVal;
  }
);

const closeDialog = () => {
  emits("update:isVisible", false);
  internalVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_dialog, {
          modelValue: internalVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalVisible).value = $event)),
          width: "auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "max-width": "400",
              "prepend-icon": "mdi-alert",
              text: "El email ya está en uso",
              title: "Error registro"
            }, {
              actions: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  class: "ms-auto",
                  text: "Ok",
                  onClick: closeDialog
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }))
}
}

})